import { render, staticRenderFns } from "./ProgramBillingContact.vue?vue&type=template&id=52fac11c&scoped=true&"
import script from "./ProgramBillingContact.vue?vue&type=script&lang=js&"
export * from "./ProgramBillingContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fac11c",
  null
  
)

export default component.exports